var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    hello!!!f\n    "),_c('b-field',{attrs:{"label":"Name"}},[_c('b-input',{attrs:{"value":"Kevin Garvey"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }